"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const qs_1 = require("qs");
const react_redux_1 = require("react-redux");
const Audience_1 = require("../Delivery/Audience");
const EventTrigger_1 = require("./EventTrigger");
const CampaignDuration_1 = require("./CampaignDuration");
const FrequencyLimits_1 = require("./FrequencyLimits");
const Form_1 = require("../Form");
const reducers_1 = require("../../../reducers");
const actions_1 = require("../../../actions");
const AutomatedDelivery = ({ device, isWizardModalClosing, updateTrigger }) => {
    const animation = isWizardModalClosing ? 'close' : 'open';
    const type = 'automateddelivery';
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            background: 'white',
            animation: `${animation} 500ms ease`,
        }, id: "automatedDelivery" },
        React.createElement(Form_1.default, { type: type, campaignId: qs_1.parse(location.search.substring(1)).campaignId, saveAndClose: updateTrigger, device: device },
            React.createElement(EventTrigger_1.default, { device: device, wizardSection: "eventTrigger" }),
            React.createElement(CampaignDuration_1.default, { device: device, wizardSection: "campaignDuration" }),
            React.createElement(Audience_1.default, { device: device, wizardSection: "audience" }),
            React.createElement(FrequencyLimits_1.default, { device: device, wizardSection: "frequencyLimits" }))));
};
const mapStateToProps = (state) => ({
    isWizardModalClosing: reducers_1.getIsWizardModalClosing(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateTrigger: () => dispatch(actions_1.updateTrigger()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AutomatedDelivery);
